import {
  groupObjectList,
  getLabelForInterior,
  isInteriorTypeDeletionBlocked,
  INTERIOR_TYPE_DELETION_BLOCKED_MESSAGE,
} from '../utils/photorealistic/interiorListHelpers';
import { deleteInterior } from '../api/rooms';

const DetectedObjectsPanel = ({
  swapped,
  image,
  addObjectActionsVisible,
  setAddObjectActionsVisible,
  removeObjectMode,
  setRemoveObjectMode,
  setRemoveObjectActionsVisible,
  handleOpenSelectObjectsPopup,
  showAllPolygonsOnCanvas,
  setShowAllPolygonsOnCanvas,
  selectedPolygonIndex,
  detectedObjectMultiSelectActive,
  multiSelectedPolygonIndices,
  setAiNotification,
  setShowPolygonsOverlay,
  setShowHistoryPanel,
  setShowMaterialsPanel,
  removeObjectActionsVisible,
  removeObjectLoading,
  handleRemoveObjectClick,
  polygons,
  detectedObjectsFromAPI,
  handleStartAddObjectFlow,
  setPendingDetectedObjects,
  setObjectChoiceStep,
  editingLayerIndex,
  isEditorToolbarActive,
  handleEditorConfirm,
  handleCancelAddObjectActions,
  setDetectedObjectMultiSelectActive,
  setMultiSelectedPolygonIndices,
  interiorTypesList,
  pendingDetectedObjects,
  polygonsLoading,
  expandedGroupLabel,
  setExpandedGroupLabel,
  objectRenameIndex,
  addingNewObjectFromPopup,
  objectChoiceStep,
  handleDetectedObjectRowClick,
  resetEditorState,
  polygonAtEditStartRef,
  objectListOverflowMenuIndex,
  setObjectListOverflowMenuIndex,
  setPolygonBottomActionsOpen,
  removeObjectRefinePending,
  setObjectBeingLabeled,
  setObjectRenameIndex,
  setNewObjectLabel,
  setNewObjectLabelDropdownOpen,
  roomId,
  roomImageId,
  setError,
  setPolygons,
  remapMultiSelectedIndicesAfterRemove,
  setSelectedPolygonIndex,
  setDeletedObjectUndo,
  deletedObjectUndo,
  handleUndoDeletedObject,
  error,
  aiNotification,
  removeObjectResultActionsVisible,
  removeResultActionsDisabled,
  handleRemoveResultRegenerate,
  handleRemoveResultRefine,
  handleRemoveResultApply,
  handleRemoveResultDownload,
  handleRemoveResultCancel,
  handleScanFromPopup,
  isGenerateMaskTaskActive,
  isImageSelectionActive = false,
}) => (
  <>
    <div className="flex shrink-0 flex-col gap-2">
      {(!swapped || removeObjectResultActionsVisible) && (
        <div className="flex flex-wrap flex-col gap-1 px-2 pt-0.5">
          <div className="mb-2 flex items-center justify-between gap-2">
            <h3 className="text-[16px] lao-mn text-gray-700">
              Objects
            </h3>
            <button
              type="button"
              onClick={() => void handleScanFromPopup()}
              disabled={polygonsLoading || isGenerateMaskTaskActive}
              className="inline-flex items-center justify-center rounded-full text-xs font-medium text-gray-700 transition-colors disabled:opacity-50 disabled:pointer-events-none"
              title={
                isImageSelectionActive
                  ? 'Re-run AI scan on the image selected in Image Selection'
                  : 'Run AI scan (generate mask)'
              }
              aria-label={
                isImageSelectionActive
                  ? 'Re-run AI scan on the image selected in Image Selection'
                  : 'Run AI scan (generate mask)'
              }
            >
              {polygonsLoading ? 'Scanning…' : 'Scan'}
            </button>
          </div>
          <div className="flex justify-between items-center gap-3 text-sm font-semibold text-gray-700 mb-2">
            <button
              type="button"
              disabled={isEditorToolbarActive}
              onClick={() => {
                setRemoveObjectMode(false);
                setRemoveObjectActionsVisible(false);
                setAddObjectActionsVisible((v) => !v);
              }}
              className={`inline-flex items-center justify-center rounded-full border p-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ${
                addObjectActionsVisible
                  ? 'border-primary-300 bg-primary-300 text-white'
                  : 'border-gray-200 bg-white text-gray-700 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300'
              }`}
              title={
                isEditorToolbarActive
                  ? 'Finish editing the current object first'
                  : addObjectActionsVisible
                    ? 'Hide add-object actions'
                    : 'Add object'
              }
              aria-label="Add object"
              aria-expanded={addObjectActionsVisible}
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                <path d="M0.75 6.75V17.15C0.75 17.71 0.75 17.99 0.859 18.204C0.954872 18.3922 1.10785 18.5451 1.296 18.641C1.51 18.75 1.79 18.75 2.348 18.75H12.75M11.75 10.75V7.75M11.75 7.75V4.75M11.75 7.75H8.75M11.75 7.75H14.75M4.75 11.55V3.95C4.75 2.83 4.75 2.27 4.968 1.842C5.16 1.465 5.465 1.16 5.842 0.968C6.27 0.75 6.83 0.75 7.95 0.75H15.55C16.67 0.75 17.23 0.75 17.658 0.968C18.0343 1.15974 18.3403 1.46569 18.532 1.842C18.75 2.27 18.75 2.83 18.75 3.95V11.55C18.75 12.67 18.75 13.23 18.532 13.658C18.3403 14.0343 18.0343 14.3403 17.658 14.532C17.23 14.75 16.672 14.75 15.554 14.75H7.947C6.829 14.75 6.269 14.75 5.842 14.532C5.46569 14.3403 5.15974 14.0343 4.968 13.658C4.75 13.23 4.75 12.67 4.75 11.55Z" strokeWidth="1.5" />
              </svg>
            </button>
            {!isImageSelectionActive && (
              <button
                type="button"
                disabled={isEditorToolbarActive}
                onClick={() => {
                  setRemoveObjectMode(false);
                  setRemoveObjectActionsVisible(false);
                  void handleOpenSelectObjectsPopup();
                }}
                className="inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-3 text-gray-700 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-color disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                title={isEditorToolbarActive ? 'Finish editing the current object first' : 'Select objects'}
                aria-label="Select objects"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                  <path d="M0.75 6.75V17.15C0.75 17.71 0.75 17.99 0.859 18.204C0.954872 18.3922 1.10785 18.5451 1.296 18.641C1.51 18.75 1.79 18.75 2.348 18.75H12.75M4.75 11.55V3.95C4.75 2.83 4.75 2.27 4.968 1.842C5.16 1.465 5.465 1.16 5.842 0.968C6.27 0.75 6.83 0.75 7.95 0.75H15.55C16.67 0.75 17.23 0.75 17.658 0.968C18.0343 1.15974 18.3403 1.46569 18.532 1.842C18.75 2.27 18.75 2.83 18.75 3.95V11.55C18.75 12.67 18.75 13.23 18.532 13.658C18.3403 14.0343 18.0343 14.3403 17.658 14.532C17.23 14.75 16.672 14.75 15.554 14.75H7.947C6.829 14.75 6.269 14.75 5.842 14.532C5.46569 14.3403 5.15974 14.0343 4.968 13.658C4.75 13.23 4.75 12.67 4.75 11.55Z" strokeWidth="1.5" />
                  <path d="M9.34961 8.073L10.7286 9.648C10.7583 9.68141 10.7952 9.70775 10.8364 9.72509C10.8776 9.74243 10.9222 9.75033 10.9669 9.74822C11.0115 9.74611 11.0552 9.73404 11.0946 9.7129C11.134 9.69175 11.1682 9.66206 11.1946 9.626L13.9946 5.75" strokeWidth="1.5" />
                </svg>
              </button>
            )}
            {image && (
              <>
                <button
                  type="button"
                  disabled={isEditorToolbarActive}
                  onClick={() => {
                    setAddObjectActionsVisible(false);
                    setRemoveObjectMode(false);
                    setRemoveObjectActionsVisible(false);
                    setShowAllPolygonsOnCanvas((v) => !v);
                  }}
                  className={`inline-flex items-center justify-center rounded-full border p-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ${
                    showAllPolygonsOnCanvas
                      ? 'border-gray-800 bg-gray-800 text-white'
                      : 'border-gray-200 bg-white text-gray-700 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-color'
                  }`}
                  title={
                    isEditorToolbarActive
                      ? 'Finish editing the current object first'
                      : showAllPolygonsOnCanvas
                        ? 'Hide all polygons on canvas'
                        : 'Show all detected objects on canvas'
                  }
                  aria-label={showAllPolygonsOnCanvas ? 'Hide all on canvas' : 'Show all on canvas'}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 24 23" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                </button>
                {!isImageSelectionActive && (
                  <button
                    type="button"
                    disabled={isEditorToolbarActive}
                    onClick={() => {
                      setAddObjectActionsVisible(false);
                      if (removeObjectMode) {
                        setRemoveObjectMode(false);
                        setRemoveObjectActionsVisible(false);
                        return;
                      }
                      const hasActiveRegion =
                        selectedPolygonIndex != null ||
                        (detectedObjectMultiSelectActive &&
                          multiSelectedPolygonIndices.size > 0);
                      if (!hasActiveRegion) {
                        setAiNotification({
                          task: 'remove_object',
                          status: 'Please select a region first',
                          message: '',
                        });
                        return;
                      }
                      setRemoveObjectMode(true);
                      setRemoveObjectActionsVisible(true);
                      setShowPolygonsOverlay(true);
                      setShowHistoryPanel(false);
                      setShowMaterialsPanel(false);
                    }}
                    className={`inline-flex items-center justify-center rounded-full border p-3 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none ${
                      removeObjectMode
                        ? 'border-gray-800 bg-gray-800 text-white'
                        : removeObjectActionsVisible
                          ? 'border-primary-300 bg-primary-300 text-white'
                          : 'bg-white hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-color'
                    }`}
                    title={
                      isEditorToolbarActive
                        ? 'Finish editing the current object first'
                        : 'Remove object mode: confirm to enable, then click delete on a polygon'
                    }
                    aria-label="Remove object mode"
                    aria-expanded={removeObjectActionsVisible}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 17 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
                      <path d="M14.25 6.75L13.41 15.148C13.283 16.421 13.22 17.057 12.93 17.538C12.6757 17.9614 12.3016 18.3 11.855 18.511C11.348 18.75 10.71 18.75 9.43 18.75H7.07C5.791 18.75 5.152 18.75 4.645 18.51C4.19805 18.2991 3.82361 17.9606 3.569 17.537C3.281 17.057 3.217 16.421 3.089 15.148L2.25 6.75M9.75 13.25V8.25M6.75 13.25V8.25M0.75 4.25H5.365M5.365 4.25L5.751 1.578C5.863 1.092 6.267 0.75 6.731 0.75H9.769C10.233 0.75 10.636 1.092 10.749 1.578L11.135 4.25M5.365 4.25H11.135M11.135 4.25H15.75" strokeWidth="1.5" />
                    </svg>
                  </button>
                )}
              </>
            )}
          </div>
          {removeObjectActionsVisible && (
            <div className="flex flex-col gap-2 mb-3 w-full" role="group" aria-label="Remove object actions">
              <div className="flex flex-row gap-2 w-full">
                <button
                  type="button"
                  disabled={removeObjectLoading || isEditorToolbarActive}
                  onClick={() => {
                    const hasActiveRegion =
                      selectedPolygonIndex != null ||
                      (detectedObjectMultiSelectActive &&
                        multiSelectedPolygonIndices.size > 0);
                    if (!hasActiveRegion) {
                      setAiNotification({
                        task: 'remove_object',
                        status: 'Please select a region first',
                        message: '',
                      });
                      return;
                    }
                    if (removeObjectMode) {
                      const anchorIndex =
                        selectedPolygonIndex != null
                          ? selectedPolygonIndex
                          : detectedObjectMultiSelectActive &&
                              multiSelectedPolygonIndices.size > 0
                            ? Math.min(...multiSelectedPolygonIndices)
                            : null;
                      if (anchorIndex == null) {
                        setAiNotification({
                          task: 'remove_object',
                          status: 'Please select a region first',
                          message: '',
                        });
                        return;
                      }
                      void handleRemoveObjectClick(anchorIndex);
                      return;
                    }
                    setRemoveObjectMode(true);
                    setShowPolygonsOverlay(true);
                    setShowHistoryPanel(false);
                    setShowMaterialsPanel(false);
                  }}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M12.5625 6.5625C12.5625 7.35043 12.4073 8.13065 12.1058 8.8586C11.8043 9.58656 11.3623 10.248 10.8051 10.8051C10.248 11.3623 9.58656 11.8043 8.8586 12.1058C8.13065 12.4073 7.35043 12.5625 6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53845 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58656 1.01922 8.8586C0.717695 8.13065 0.5625 7.35043 0.5625 6.5625C0.5625 4.9712 1.19464 3.44508 2.31986 2.31986C3.44508 1.19464 4.9712 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.34033 6.98445L5.34367 8.13178C5.40969 8.20734 5.49192 8.26701 5.58422 8.30636C5.67652 8.34571 5.77651 8.36372 5.87674 8.35904C5.97697 8.35436 6.07485 8.32712 6.16308 8.27934C6.25132 8.23157 6.32763 8.16449 6.38633 8.08312L8.78433 4.76245" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  {aiNotification?.task === 'remove_object' && aiNotification?.status === 'Failed'
                    ? 'Retry'
                    : 'Confirm'}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setRemoveObjectActionsVisible(false);
                    setRemoveObjectMode(false);
                  }}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M8.5625 8.5625L4.5625 4.5625M8.5625 4.5625L4.5625 8.5625M6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53844 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58655 1.01922 8.8586C0.717693 8.13065 0.562499 7.35043 0.562499 6.5625C0.562499 5.77457 0.717693 4.99435 1.01922 4.2664C1.32075 3.53845 1.76271 2.87701 2.31986 2.31986C2.87701 1.76271 3.53844 1.32075 4.2664 1.01922C4.99435 0.717694 5.77457 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625C12.5625 8.1538 11.9304 9.67992 10.8051 10.8051C9.67992 11.9304 8.1538 12.5625 6.5625 12.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Cancel
                </button>
              </div>
            </div>
          )}
          {removeObjectResultActionsVisible && (
            <div className="flex flex-col gap-2 mb-3 w-full" role="group" aria-label="Remove object result actions">
              <div className="flex flex-col gap-2 w-full">
              <button
                  type="button"
                  disabled={removeResultActionsDisabled}
                  onClick={handleRemoveResultApply}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M12.5625 6.5625C12.5625 7.35043 12.4073 8.13065 12.1058 8.8586C11.8043 9.58656 11.3623 10.248 10.8051 10.8051C10.248 11.3623 9.58656 11.8043 8.8586 12.1058C8.13065 12.4073 7.35043 12.5625 6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53845 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58656 1.01922 8.8586C0.717695 8.13065 0.5625 7.35043 0.5625 6.5625C0.5625 4.9712 1.19464 3.44508 2.31986 2.31986C3.44508 1.19464 4.9712 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.34033 6.98445L5.34367 8.13178C5.40969 8.20734 5.49192 8.26701 5.58422 8.30636C5.67652 8.34571 5.77651 8.36372 5.87674 8.35904C5.97697 8.35436 6.07485 8.32712 6.16308 8.27934C6.25132 8.23157 6.32763 8.16449 6.38633 8.08312L8.78433 4.76245" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Apply
                </button>
                </div>
                <div className="flex flex-row gap-2 w-full">
                  <button
                    type="button"
                    disabled={removeResultActionsDisabled}
                    onClick={handleRemoveResultRegenerate}
                    className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                  >
                    <svg className="w-4 h-4" viewBox="0 0 14 10" fill="none" aria-hidden="true">
                      <path d="M3.65635 0.577148H12.894M3.65635 4.81105H12.894M3.65635 9.04495H12.894M0.577148 0.577148H1.34695M0.577148 4.81105H1.34695M0.577148 9.04495H1.34695" stroke="currentColor" strokeWidth="1.1547" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                    Regen
                  </button>
                  <button
                    type="button"
                    disabled={removeResultActionsDisabled}
                    onClick={handleRemoveResultRefine}
                    className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 17 17" fill="currentColor" aria-hidden="true">
                      <path d="M14.3 1.65C14.3 2.08761 14.4738 2.50729 14.7833 2.81673C15.0927 3.12616 15.5124 3.3 15.95 3.3C16.3876 3.3 16.8073 3.12616 17.1167 2.81673C17.4262 2.50729 17.6 2.08761 17.6 1.65C17.6 1.21239 17.4262 0.792709 17.1167 0.483274C16.8073 0.173839 16.3876 0 15.95 0C15.5124 0 15.0927 0.173839 14.7833 0.483274C14.4738 0.792709 14.3 1.21239 14.3 1.65ZM0 13.75C0 13.9667 0.0426786 14.1812 0.125599 14.3814C0.208519 14.5816 0.330057 14.7635 0.483274 14.9167C0.636491 15.0699 0.818385 15.1915 1.01857 15.2744C1.21876 15.3573 1.43332 15.4 1.65 15.4C1.86668 15.4 2.08124 15.3573 2.28143 15.2744C2.48162 15.1915 2.66351 15.0699 2.81673 14.9167C2.96994 14.7635 3.09148 14.5816 3.1744 14.3814C3.25732 14.1812 3.3 13.9667 3.3 13.75C3.3 13.3124 3.12616 12.8927 2.81673 12.5833C2.50729 12.2738 2.08761 12.1 1.65 12.1C1.21239 12.1 0.792709 12.2738 0.483274 12.5833C0.173839 12.8927 0 13.3124 0 13.75ZM4.4 1.65C4.4 2.08761 4.57384 2.50729 4.88327 2.81673C5.19271 3.12616 5.61239 3.3 6.05 3.3C6.48761 3.3 6.90729 3.12616 7.21673 2.81673C7.52616 2.50729 7.7 2.08761 7.7 1.65C7.7 1.21239 7.52616 0.792709 7.21673 0.483274C6.90729 0.173839 6.48761 0 6.05 0C5.61239 0 5.19271 0.173839 4.88327 0.483274C4.57384 0.792709 4.4 1.21239 4.4 1.65ZM8.6746 2.475H13.3265C13.1576 1.93797 13.1576 1.36203 13.3265 0.825H8.6735C8.84239 1.36203 8.84349 1.93797 8.6746 2.475ZM1.771 11.0022L4.378 3.8335C4.8114 4.1657 5.346 4.3725 5.929 4.3978L3.322 11.5665C2.87497 11.224 2.33358 11.0271 1.771 11.0022ZM4.2746 14.575H8.1488L8.1752 14.4705C8.3039 13.9568 8.5459 13.4794 8.8836 13.0735C8.8968 13.0236 8.9111 12.9741 8.9265 12.925H4.2735C4.44239 13.462 4.44349 14.038 4.2746 14.575ZM15.829 4.3978L14.817 7.183C14.6732 7.28564 14.5378 7.39968 14.4122 7.524L12.0923 9.845L14.278 3.8335C14.7114 4.1657 15.246 4.3725 15.829 4.3978ZM9.878 13.6158L15.191 8.3028C15.3815 8.1094 15.6084 7.95562 15.8586 7.85032C16.1088 7.74503 16.3774 7.6903 16.6489 7.6893C16.9204 7.6883 17.1893 7.74105 17.4403 7.8445C17.6913 7.94794 17.9193 8.10005 18.1113 8.29204C18.3032 8.48404 18.4552 8.71212 18.5586 8.96315C18.6619 9.21417 18.7146 9.48317 18.7135 9.75464C18.7123 10.0261 18.6575 10.2947 18.5521 10.5449C18.4467 10.795 18.2929 11.0219 18.0994 11.2123L12.7864 16.5242C12.4768 16.8337 12.089 17.0535 11.6644 17.16L10.0166 17.5714C9.85275 17.6122 9.68113 17.61 9.5184 17.5649C9.35568 17.5198 9.20739 17.4334 9.08793 17.314C8.96847 17.1947 8.88192 17.0465 8.83667 16.8838C8.79142 16.7211 8.78902 16.5495 8.8297 16.3856L9.2422 14.7378C9.34875 14.3132 9.56848 13.9254 9.878 13.6158Z">
                      </path>
                    </svg>
                    Refine
                  </button>
                </div>
              <div className="flex flex-row gap-2 w-full">
                <button
                  type="button"
                  disabled={removeResultActionsDisabled}
                  onClick={handleRemoveResultDownload}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4" />
                          <polyline points="7 10 12 15 17 10" />
                          <line x1="12" y1="15" x2="12" y2="3" />
                        </svg>
                  Download
                </button>
                <button
                  type="button"
                  disabled={removeResultActionsDisabled}
                  onClick={handleRemoveResultCancel}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:pointer-events-none"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M8.5625 8.5625L4.5625 4.5625M8.5625 4.5625L4.5625 8.5625M6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53844 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58655 1.01922 8.8586C0.717693 8.13065 0.562499 7.35043 0.562499 6.5625C0.562499 5.77457 0.717693 4.99435 1.01922 4.2664C1.32075 3.53845 1.76271 2.87701 2.31986 2.31986C2.87701 1.76271 3.53844 1.32075 4.2664 1.01922C4.99435 0.717694 5.77457 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625C12.5625 8.1538 11.9304 9.67992 10.8051 10.8051C9.67992 11.9304 8.1538 12.5625 6.5625 12.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  Cancel
                </button>
              </div>
            </div>
          )}
          {addObjectActionsVisible && (
            <div className="flex flex-col gap-2 mb-3 w-full" role="group" aria-label="Add object actions">
              <button
                type="button"
                disabled={isEditorToolbarActive}
                onClick={() => {
                  const baseList =
                    Array.isArray(polygons) && polygons.length > 0
                      ? polygons
                      : detectedObjectsFromAPI;
                  handleStartAddObjectFlow(baseList);
                  setPendingDetectedObjects(null);
                  setObjectChoiceStep('initial');
                }}
                title={
                  isEditorToolbarActive
                    ? 'Finish editing the current object before adding another'
                    : 'Add another object'
                }
                aria-disabled={isEditorToolbarActive}
                className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-gray-200 disabled:hover:text-primary-300"
              >
                <svg className="w-4 h-4" viewBox="0 0 13 13" fill="none" stroke="currentColor" aria-hidden="true">
                  <path d="M6.5 8.83333L6.5 6.5M6.5 6.5V4.16667M6.5 6.5L8.83333 6.5M6.5 6.5L4.16667 6.5M6.5 12.5C5.71207 12.5 4.93185 12.3448 4.2039 12.0433C3.47595 11.7417 2.81451 11.2998 2.25736 10.7426C1.70021 10.1855 1.25825 9.52405 0.956722 8.7961C0.655194 8.06815 0.5 7.28793 0.5 6.5C0.5 5.71207 0.655194 4.93185 0.956722 4.2039C1.25825 3.47595 1.70021 2.81451 2.25736 2.25736C2.81451 1.70021 3.47595 1.25825 4.2039 0.956722C4.93185 0.655194 5.71207 0.5 6.5 0.5C8.0913 0.5 9.61742 1.13214 10.7426 2.25736C11.8679 3.38258 12.5 4.9087 12.5 6.5C12.5 8.0913 11.8679 9.61742 10.7426 10.7426C9.61742 11.8679 8.0913 12.5 6.5 12.5Z" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
                Add another object
              </button>
              <div className="flex flex-row gap-2 mb-3 w-full">
                <button
                  type="button"
                  onClick={() => {
                    if (editingLayerIndex != null) {
                      void handleEditorConfirm();
                    } else {
                      setAddObjectActionsVisible(false);
                    }
                  }}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M12.5625 6.5625C12.5625 7.35043 12.4073 8.13065 12.1058 8.8586C11.8043 9.58656 11.3623 10.248 10.8051 10.8051C10.248 11.3623 9.58656 11.8043 8.8586 12.1058C8.13065 12.4073 7.35043 12.5625 6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53845 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58656 1.01922 8.8586C0.717695 8.13065 0.5625 7.35043 0.5625 6.5625C0.5625 4.9712 1.19464 3.44508 2.31986 2.31986C3.44508 1.19464 4.9712 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.34033 6.98445L5.34367 8.13178C5.40969 8.20734 5.49192 8.26701 5.58422 8.30636C5.67652 8.34571 5.77651 8.36372 5.87674 8.35904C5.97697 8.35436 6.07485 8.32712 6.16308 8.27934C6.25132 8.23157 6.32763 8.16449 6.38633 8.08312L8.78433 4.76245" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Confirm
                </button>
                <button
                  type="button"
                  onClick={handleCancelAddObjectActions}
                  className="flex flex-row justify-center items-center gap-2 w-full rounded-full border border-gray-200 bg-white px-3 py-2 text-sm font-medium text-primary-300 hover:bg-primary-500 hover:border-primary-300 hover:text-primary-300 transition-colors"
                >
                  <svg className="w-4 h-4" viewBox="0 0 14 14" fill="none" stroke="currentColor" aria-hidden="true">
                    <path d="M8.5625 8.5625L4.5625 4.5625M8.5625 4.5625L4.5625 8.5625M6.5625 12.5625C5.77457 12.5625 4.99435 12.4073 4.2664 12.1058C3.53844 11.8043 2.87701 11.3623 2.31986 10.8051C1.76271 10.248 1.32075 9.58655 1.01922 8.8586C0.717693 8.13065 0.562499 7.35043 0.562499 6.5625C0.562499 5.77457 0.717693 4.99435 1.01922 4.2664C1.32075 3.53845 1.76271 2.87701 2.31986 2.31986C2.87701 1.76271 3.53844 1.32075 4.2664 1.01922C4.99435 0.717694 5.77457 0.5625 6.5625 0.5625C8.1538 0.5625 9.67992 1.19464 10.8051 2.31986C11.9304 3.44508 12.5625 4.9712 12.5625 6.5625C12.5625 8.1538 11.9304 9.67992 10.8051 10.8051C9.67992 11.9304 8.1538 12.5625 6.5625 12.5625Z" strokeWidth="1.125" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </div>
      )}

      <div className="flex items-center justify-between gap-2 px-2">
        <h3 className="flex items-center gap-2 text-[16px] lao-mn text-gray-700">
          Detected Objects
        </h3>
        <div className="flex items-center gap-0.5 shrink-0">
          <label
            className={`flex items-center rounded-md p-1.5 text-gray-600 transition-colors ${
              isEditorToolbarActive
                ? 'cursor-not-allowed opacity-50'
                : 'cursor-pointer hover:bg-gray-100 hover:text-gray-900'
            }`}
            title={
              isEditorToolbarActive
                ? 'Finish editing the current object first'
                : detectedObjectMultiSelectActive
                  ? 'Turn off multi-select'
                  : 'Select multiple objects'
            }
          >
            <input
              type="checkbox"
              className="pr-object-checkbox"
              disabled={isEditorToolbarActive}
              checked={detectedObjectMultiSelectActive}
              onChange={(e) => {
                const on = e.target.checked;
                setDetectedObjectMultiSelectActive(on);
                if (!on) {
                  setMultiSelectedPolygonIndices(new Set());
                  return;
                }
                setMultiSelectedPolygonIndices((prev) => {
                  const next = new Set(prev);
                  if (selectedPolygonIndex != null) next.add(selectedPolygonIndex);
                  return next;
                });
              }}
              aria-label="Select multiple detected objects"
            />
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 ml-1" aria-hidden>
              <path d="M12.83 2.18a2 2 0 0 0-1.66 0L2.6 6.08a1 1 0 0 0 0 1.83l8.58 3.91a2 2 0 0 0 1.66 0l8.58-3.9a1 1 0 0 0 0-1.83Z" />
              <path d="M22 17.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 17.65" />
              <path d="M22 12.65l-9.17 4.16a2 2 0 0 1-1.66 0L2 12.65" />
            </svg>
          </label>
        </div>
      </div>
    </div>
    <div className="flex-1 min-h-0 overflow-y-auto space-y-1 px-2">
      {pendingDetectedObjects != null ? (
        <p className="text-gray-500 text-sm py-2">Confirm your selection in the popup to see the object list here.</p>
      ) : polygonsLoading ? (
        <p className="text-gray-500 text-sm py-2">Detecting objects...</p>
      ) : polygons?.length > 0 ? (
        groupObjectList(polygons, interiorTypesList).map((grp) => {
          const isSingle = grp.indices.length === 1;
          const isExpanded = expandedGroupLabel === grp.label;

          const renderRow = (item, i) => {
            const hideActionsForPendingNewObject =
              objectRenameIndex == null &&
              i === 0 &&
              (addingNewObjectFromPopup || objectChoiceStep === 'editNewObjectLabel');
            const rowLocked =
              (isEditorToolbarActive &&
                !removeObjectRefinePending &&
                editingLayerIndex != null &&
                i !== editingLayerIndex) ||
              (removeObjectRefinePending &&
                detectedObjectMultiSelectActive &&
                !multiSelectedPolygonIndices.has(i));
            const structuralRemoveBlocked =
              removeObjectMode && isInteriorTypeDeletionBlocked(item, interiorTypesList, i);
            const rowInteractionDisabled = rowLocked || structuralRemoveBlocked;
            return (
              <div
                key={i}
                onClick={(e) => {
                  if (rowInteractionDisabled) return;
                  if (e.target.closest('button')) return;
                  if (e.target.closest('input')) return;
                  if (e.target.closest('[role="listbox"]')) return;
                  if (e.target.closest('[data-object-row-overflow]')) return;
                  handleDetectedObjectRowClick(i, polygons);
                }}
                className={`flex items-center gap-2 justify-between py-2 px-3 rounded-full border ${
                  rowInteractionDisabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                } ${selectedPolygonIndex === i ||
                  (detectedObjectMultiSelectActive && multiSelectedPolygonIndices.has(i))
                  ? 'bg-gray-50 text-white border-gray-900'
                  : `bg-white border-gray-200${rowInteractionDisabled ? '' : ' hover:bg-gray-50'}`
                  } group`}
                title={
                  structuralRemoveBlocked
                    ? INTERIOR_TYPE_DELETION_BLOCKED_MESSAGE
                    : undefined
                }
              >
                <span className="text-sm text-[#696969] truncate flex-1 min-w-0">
                  {getLabelForInterior(item, interiorTypesList, i)}
                </span>
                {detectedObjectMultiSelectActive && (
                  <input
                    type="checkbox"
                    className="pr-object-checkbox shrink-0"
                    disabled={rowInteractionDisabled}
                    checked={multiSelectedPolygonIndices.has(i)}
                    onClick={(e) => e.stopPropagation()}
                    onChange={() => {
                      if (!rowInteractionDisabled) handleDetectedObjectRowClick(i, polygons);
                    }}
                    aria-label={`Select ${getLabelForInterior(item, interiorTypesList, i)}`}
                  />
                )}
                <div className="flex items-center gap-0.5 shrink-0 hidden">
                  <button
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      if (editingLayerIndex === i) {
                        setEditingLayerIndex(null);
                        resetEditorState();
                      } else {
                        polygonAtEditStartRef.current = { ...item };
                        setEditingLayerIndex(i);
                        resetEditorState();
                      }
                    }}
                    className={`p-1.5 rounded-full transition-colors ${editingLayerIndex === i
                      ? 'bg-gray-800 text-white'
                      : 'text-[#696969] hover:text-gray-600'
                      }`}
                    title="Edit layer"
                    aria-label={`Edit ${getLabelForInterior(item, interiorTypesList, i)}`}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="m9.06 11.9 8.07-8.06a2.85 2.85 0 1 1 4.03 4.03l-8.06 8.08" />
                      <path d="M7.07 14.94c-1.66 0-3 1.35-3 3.02 0 1.33-2.5 1.52-2 2.02 1.08 1.1 2.49 2.02 4 2.02 2.2 0 4-1.8 4-4.04a3.01 3.01 0 0 0-3-3.02z" />
                    </svg>
                  </button>
                  {!hideActionsForPendingNewObject && (
                    <div className="relative" data-object-row-overflow>
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation();
                          setObjectListOverflowMenuIndex((prev) => (prev === i ? null : i));
                        }}
                        className={`p-1.5 rounded-full transition-colors ${objectListOverflowMenuIndex === i
                          ? 'bg-gray-200 text-gray-800'
                          : 'text-[#696969] hover:text-gray-600'
                          }`}
                        title="More actions"
                        aria-expanded={objectListOverflowMenuIndex === i}
                        aria-haspopup="true"
                        aria-label={`More actions for ${getLabelForInterior(item, interiorTypesList, i)}`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden>
                          <circle cx="12" cy="5" r="1.5" />
                          <circle cx="12" cy="12" r="1.5" />
                          <circle cx="12" cy="19" r="1.5" />
                        </svg>
                      </button>
                      {objectListOverflowMenuIndex === i && (
                        <div
                          role="menu"
                          className="absolute right-5 top-[-6px] z-40 min-w-[5rem] rounded-lg border border-gray-200 bg-white py-1 shadow-lg"
                          onClick={(e) => e.stopPropagation()}
                        >
                          <button
                            type="button"
                            role="menuitem"
                            className="flex w-full items-center gap-2 px-2 py-1 text-left text-sm text-gray-700 hover:bg-gray-100"
                            onClick={(e) => {
                              e.stopPropagation();
                              setObjectListOverflowMenuIndex(null);
                              if (editingLayerIndex != null) {
                                setEditingLayerIndex(null);
                                resetEditorState();
                              }
                              setPolygonBottomActionsOpen(false);
                              setObjectBeingLabeled(item);
                              setObjectRenameIndex(i);
                              setNewObjectLabel(getLabelForInterior(item, interiorTypesList, i) || '');
                              setNewObjectLabelDropdownOpen(false);
                              setObjectChoiceStep('editNewObjectLabel');
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0" aria-hidden>
                              <path d="M12 20h9" />
                              <path d="M16.5 3.5a2.12 2.12 0 1 1 3 3L7 19l-4 1 1-4Z" />
                            </svg>
                            Rename
                          </button>
                          <button
                            type="button"
                            role="menuitem"
                            className="flex w-full items-center gap-2 px-2 py-1 text-left text-sm text-red-600 hover:bg-red-50"
                            onClick={async (e) => {
                              e.stopPropagation();
                              if (isInteriorTypeDeletionBlocked(item, interiorTypesList, i)) {
                                setObjectListOverflowMenuIndex(null);
                                setAiNotification({
                                  task: 'delete_detection',
                                  status: '',
                                  message: INTERIOR_TYPE_DELETION_BLOCKED_MESSAGE,
                                });
                                return;
                              }
                              const objectLabel = getLabelForInterior(item, interiorTypesList, i);
                              const interiorId = item.interior_id ?? item.id;
                              const willDeleteOnServer =
                                roomId != null && roomImageId != null && interiorId != null;
                              const confirmMessage = willDeleteOnServer
                                ? `Remove object detection for "${objectLabel}"? This permanently deletes the saved detection on the server and removes it from your list.`
                                : `Remove "${objectLabel}" from your detected objects list?`;
                              if (!window.confirm(confirmMessage)) return;
                              setObjectListOverflowMenuIndex(null);
                              if (willDeleteOnServer) {
                                try {
                                  await deleteInterior(roomId, roomImageId, interiorId);
                                } catch (err) {
                                  setError(err.message ?? 'Failed to delete object');
                                  return;
                                }
                              }
                              setPolygons((prev) => prev.filter((_, idx) => idx !== i));
                              remapMultiSelectedIndicesAfterRemove(i);
                              setSelectedPolygonIndex((sel) => {
                                if (sel == null) return null;
                                if (sel === i) return null;
                                if (sel > i) return sel - 1;
                                return sel;
                              });
                              if (editingLayerIndex === i) {
                                setEditingLayerIndex(null);
                                resetEditorState();
                              } else if (editingLayerIndex != null && editingLayerIndex > i) {
                                setEditingLayerIndex(editingLayerIndex - 1);
                              }
                              if (willDeleteOnServer) {
                                setDeletedObjectUndo({
                                  label: objectLabel,
                                  roomId,
                                  roomImageId,
                                  interiorId,
                                  item: { ...item },
                                  index: i,
                                  restoring: false,
                                });
                              } else {
                                setDeletedObjectUndo(null);
                              }
                            }}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="shrink-0" aria-hidden>
                              <path d="M3 6h18" />
                              <path d="M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6" />
                              <path d="M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2" />
                              <line x1="10" y1="11" x2="10" y2="17" />
                              <line x1="14" y1="11" x2="14" y2="17" />
                            </svg>
                            Delete
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          };

          if (isSingle) {
            const i = grp.indices[0];
            const item = polygons[i];
            return <div key={grp.firstIndex ?? i}>{renderRow(item, i)}</div>;
          }

          return (
            <div key={`group-${grp.label}`} className="space-y-0.5">
              <button
                type="button"
                disabled={isEditorToolbarActive}
                onClick={() => setExpandedGroupLabel(isExpanded ? null : grp.label)}
                className="w-full flex items-center gap-2 justify-between py-2 px-3 rounded-full text-left border bg-white border-gray-200 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed disabled:pointer-events-none"
                title={
                  isEditorToolbarActive
                    ? 'Finish editing the current object before changing group view'
                    : undefined
                }
              >
                <span className="text-sm text-[#696969] truncate">{grp.label} ({grp.indices.length})</span>
                <svg
                  className={`w-4 h-4 text-gray-500 shrink-0 transition-transform ${isExpanded ? 'rotate-180' : ''}`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                </svg>
              </button>
              {isExpanded && (
                <div className="pl-2 border-l-2 border-gray-200 space-y-1">
                  {grp.indices.map((i) => {
                    const item = polygons[i];
                    return renderRow(item, i);
                  })}
                </div>
              )}
            </div>
          );
        })
      ) : (
        <p className="text-gray-500 text-sm py-2">No objects detected yet</p>
      )}
    </div>
    {deletedObjectUndo && (
      <div className="text-sm text-gray-700 bg-gray-50 p-3 rounded border border-gray-200 shrink-0 flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 shrink-0">
          <span className="truncate">
            {deletedObjectUndo.batchItems
              ? `${deletedObjectUndo.batchItems.length} detections were removed.`
              : `${deletedObjectUndo.label} was removed.`}
          </span>
          <button
            type="button"
            className="text-sm font-medium text-gray-900 hover:text-black underline underline-offset-2 disabled:opacity-60 disabled:no-underline"
            onClick={handleUndoDeletedObject}
            disabled={deletedObjectUndo.restoring}
          >
            {deletedObjectUndo.restoring ? 'Undoing...' : 'Undo'}
          </button>
        </div>
          <button
            type="button"
            className="p-1 rounded text-gray-400 hover:text-gray-700 hover:bg-gray-200 transition-colors"
            aria-label="Close notification"
            title="Close notification"
            onClick={() => setDeletedObjectUndo(null)}
            disabled={deletedObjectUndo.restoring}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
              <path d="M18 6 6 18" />
              <path d="m6 6 12 12" />
            </svg>
          </button>
      </div>
    )}
    {/*
    {error && (
      <div className="text-sm text-red-600 bg-red-50 p-3 rounded border border-red-200 shrink-0">
        {error}
      </div>
    )}*/}
  </>
);

export default DetectedObjectsPanel;
